// extracted by mini-css-extract-plugin
export default {"range":"Title_range__3GM0C","popover":"Title_popover__9Cv95"};